import React, { useEffect } from 'react'
import classNames from 'classnames'
import FocusTrap from 'focus-trap-react'

import { Item } from '../types'

import style from './index.module.scss'
import Pane from './pane'

export const Nav: React.FC<{
  className?: string
  items: Item[]
  initialPath?: number[]
  onClose: () => void
  menuId?: string
}> = ({ className, items, initialPath, onClose, menuId }) => {
  useEffect(() => {
    function keyHandler(e: KeyboardEvent): void {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    window.addEventListener('keydown', keyHandler)
    return () => window.removeEventListener('keydown', keyHandler)
  }, [onClose])

  return (
    <FocusTrap>
      <div // eslint-disable-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        className={classNames(className, style.nav)}
        id={menuId}
        onClick={onClose}
      >
        <div // eslint-disable-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          className={classNames(style.contents)}
          onClick={e => e.stopPropagation()}
        >
          <Pane items={items} initialPath={initialPath} onExit={onClose} />
        </div>
      </div>
    </FocusTrap>
  )
}
